"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6821],{

/***/ 64331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V$": function() { return /* binding */ connectToParentPage; }
});

// UNUSED EXPORTS: connectToIframe, failHandshake

// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37891);
;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/is-controller-message.js
function is_controller_message_isControllerMessage(event) {
    var message = event.data;
    return (message === null || message === void 0 ? void 0 : message.meta) && message.data;
}
/* harmony default export */ var is_controller_message = (is_controller_message_isControllerMessage);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/message-handler.js

function messageHandler(messageType, callback) {
    return function(event) {
        if (!is_controller_message(event)) {
            return;
        }
        var _data = event.data, meta = _data.meta, data = _data.data;
        if (meta.messageType === messageType) {
            callback({
                meta: meta,
                data: data
            });
        }
    };
}
/* harmony default export */ var message_handler = (messageHandler);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/child-to-parent-bridge.js


function ChildToParentBridge(param) {
    var iframeId = param.iframeId, _initialData = param.initialData, initialData = _initialData === void 0 ? {} : _initialData;
    var postParentMessage = createPostFn(iframeId);
    postParentMessage("handshake-reply");
    window.addEventListener("message", message_handler("data-request", function(param) {
        var data = param.data;
        postParentMessage("data-reply", (0,_define_property/* default */.Z)({}, data.key, initialData[data.key]));
    }));
    return {
        emit: function(eventName, data) {
            postParentMessage("event", {
                eventName: eventName,
                eventData: data
            });
        },
        get: function(key) {
            return new Promise(function(resolve) {
                var dataReply = message_handler("data-reply", function(param) {
                    var data = param.data;
                    window.removeEventListener("message", dataReply, false);
                    resolve(data[key]);
                });
                window.addEventListener("message", dataReply, false);
                postParentMessage("data-request", {
                    key: key
                });
            });
        }
    };
}
function createPostFn(iframeId) {
    return function(messageType, data) {
        window.parent.postMessage({
            meta: {
                messageType: messageType,
                sourceId: iframeId
            },
            data: data || {}
        }, "*");
    };
}
/* harmony default export */ var child_to_parent_bridge = (ChildToParentBridge);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/index.js





function connectToIframe(param) {
    var iframe = param.iframe, hostURL = param.hostURL, _dataRequestHandlers = param.dataRequestHandlers, dataRequestHandlers = _dataRequestHandlers === void 0 ? {} : _dataRequestHandlers;
    var iframeId = uuid();
    // eslint-disable-next-line no-param-reassign
    iframe.src = "".concat(iframe.src, "#!iframeId=").concat(iframeId);
    var connection = new Promise(function(resolve, reject) {
        function reply(event) {
            if (!isControllerMessage(event)) {
                return;
            }
            var _data = event.data, meta = _data.meta, data = _data.data;
            if (meta.sourceId !== iframeId) {
                return;
            }
            if (meta.messageType === "handshake-reply") {
                clearInterval(intervalId);
                window.removeEventListener("message", reply, false);
                resolve(ParentToChildBridge({
                    hostURL: hostURL,
                    iframeId: iframeId,
                    iframe: iframe,
                    dataRequestHandlers: dataRequestHandlers
                }));
            }
            if (meta.messageType === "handshake-failed") {
                clearInterval(intervalId);
                window.removeEventListener("message", reply, false);
                var err = new Error("Handshake to iframe failed");
                err.data = data;
                reject(err);
            }
        }
        window.addEventListener("message", reply, false);
    });
    // Emit handshake message when the iframe navigates to a
    // new page so the new page can emit messages to the parent
    iframe.addEventListener("load", function() {
        if (!iframe.src.includes("iframeId=")) {
            // eslint-disable-next-line no-param-reassign
            iframe.src = "".concat(iframe.src, "#!iframeId=").concat(iframeId);
        }
        iframe.contentWindow.postMessage({
            meta: {
                messageType: "handshake"
            },
            data: {
                iframeId: iframeId
            }
        }, hostURL);
    });
    var intervalId = setInterval(function() {
        // Because the iframe's origin is the same as the host page's until it
        // loads, postMesssage would log an error about mismatched origin. If we can
        // see that the origin is the same as the parent page, we dont try to post.
        if (isIframeSameOrigin(iframe)) {
            return;
        }
        // iframe has been removed from the page, stop trying the handshake
        if (!iframe.contentWindow) {
            clearInterval(intervalId);
            return;
        }
        iframe.contentWindow.postMessage({
            meta: {
                messageType: "handshake"
            },
            data: {
                iframeId: iframeId
            }
        }, hostURL);
    }, 100);
    return connection;
}
function connectToParentPage() {
    var parentAccessibleData = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).parentAccessibleData;
    return new Promise(function(resolve) {
        function handshake(event) {
            if (!is_controller_message(event)) {
                return;
            }
            var _data = event.data, meta = _data.meta, data = _data.data;
            if (meta.messageType === "handshake") {
                var iframeId = data.iframeId;
                if (window.location.href.includes("iframeId=".concat(iframeId)) || !window.location.href.includes("iframeId=")) {
                    window.removeEventListener("message", handshake, false);
                    var bridge = child_to_parent_bridge({
                        iframeId: data.iframeId,
                        initialData: parentAccessibleData
                    });
                    resolve(bridge);
                }
            }
        }
        window.addEventListener("message", handshake, false);
    });
}
/**
 *  failHandshake()
 *  Called from an error script served in the iframe
 */ function failHandshake(errorData) {
    function handshake(event) {
        if (!isControllerMessage(event)) {
            return;
        }
        var _data = event.data, meta = _data.meta, data = _data.data;
        if (meta.messageType === "handshake") {
            window.removeEventListener("message", handshake, false);
            postHandshakeFailMessage(data.iframeId, errorData);
        }
    }
    window.addEventListener("message", handshake, false);
}
function postHandshakeFailMessage(iframeId, data) {
    window.parent.postMessage({
        meta: {
            messageType: "handshake-failed",
            sourceId: iframeId
        },
        data: data
    }, "*");
}


/***/ }),

/***/ 28420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Branding; }
});

// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7464);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(68641);
// EXTERNAL MODULE: ../../../../libraries/src/url/index.ts
var url = __webpack_require__(11523);
// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(23670);
// EXTERNAL MODULE: ../../../../../node_modules/i18next/dist/esm/i18next.js + 1 modules
var i18next = __webpack_require__(36148);
// EXTERNAL MODULE: ../../../../translations/index.ts
var translations = __webpack_require__(24043);
// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(78149);
// EXTERNAL MODULE: ../../../../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76688);
;// CONCATENATED MODULE: ../../../../translations/locale.ts


var preferredLocales = {
    en: "en-US",
    en_US: "en-US",
    en_GB: "en-GB",
    es: "es-MX",
    es_MX: "es-MX",
    de: "de-DE",
    de_DE: "de-DE",
    it: "it-IT",
    it_IT: "it-IT",
    fr: "fr-FR",
    fr_FR: "fr-FR",
    nl: "nl-NL",
    nl_NL: "nl-NL"
};
function localeFromString(str) {
    if (str) {
        var localeKey = str.toLowerCase();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(preferredLocales)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), k = _value[0], v = _value[1];
                if (localeKey === v.toLowerCase() || localeKey === k.toLowerCase()) {
                    return v;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return preferredLocales.en_US;
}
function possibleLocales() {
    var ref;
    if (!window) {
        return [
            "en"
        ];
    }
    var shopify = window.Shopify;
    var shopifyLocale = null;
    if (shopify === null || shopify === void 0 ? void 0 : shopify.locale) {
        if (shopify.locale.includes("-")) {
            shopifyLocale = shopify.locale;
        } else if (shopify.country) {
            shopifyLocale = "".concat(shopify.locale, "-").concat(shopify.country);
        } else {
            shopifyLocale = shopify.locale;
        }
    }
    var queryParamLocale = new URLSearchParams(window.location.search).get("locale");
    return [
        queryParamLocale,
        (ref = window.PurpleDotConfig) === null || ref === void 0 ? void 0 : ref.locale,
        shopifyLocale,
        document.documentElement.lang, 
    ].concat((0,_to_consumable_array/* default */.Z)(navigator.languages), [
        "en", 
    ]).filter(function(l) {
        return l != null;
    });
}
function autoDetectLocale() {
    return localeFromString(possibleLocales()[0]);
}

;// CONCATENATED MODULE: ../../../../translations/i18n.ts





// Configure a backend that loads translations asynchronously.
// This works using webpack code splitting to load translations on demand.
// We only load the badly named "shopify" namespace because it contains
// the specific frontend translations.
var i18nLoading = i18next/* default.isInitialized */.ZP.isInitialized ? Promise.resolve() : i18next/* default.use */.ZP.use({
    type: "backend",
    read: function read(language, namespace, callback) {
        (0,translations/* loadAsync */.vA)(language, namespace).then(function(resources) {
            callback(null, resources);
        }).catch(function(error) {
            callback(error, null);
        });
    }
}).use({
    type: "languageDetector",
    detect: function detect() {
        return autoDetectLocale();
    }
}).init((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, translations/* baseConfig */.uN), {
    ns: [
        "shopify"
    ],
    lng: undefined
}));
// Give the translations up to 5 seconds to load before giving up and just rendering anyway
var i18nReady = Promise.race([
    // biome-ignore lint/nursery/noConsole: old
    i18nLoading.catch(function(error) {
        return console.error(error);
    }),
    new Promise(function(resolve) {
        setTimeout(resolve, 5000);
    }), 
]);
var t = i18next/* default.getFixedT */.ZP.getFixedT(null, "shopify");
var addResourceBundle = i18next/* default.addResourceBundle.bind */.ZP.addResourceBundle.bind(i18next/* default */.ZP);

;// CONCATENATED MODULE: ../../../../web-components/learn-more/learn-more-modal.ts




function createLearnMoreButton() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _HOST = ref.HOST, HOST = _HOST === void 0 ? "https://www.purpledotprice.com" : _HOST, _hideBackToProduct = ref.hideBackToProduct, hideBackToProduct = _hideBackToProduct === void 0 ? false : _hideBackToProduct, _isAddToPreorder = ref.isAddToPreorder, isAddToPreorder = _isAddToPreorder === void 0 ? false : _isAddToPreorder, _useExtendedDeliveryLanguage = ref.useExtendedDeliveryLanguage, useExtendedDeliveryLanguage = _useExtendedDeliveryLanguage === void 0 ? false : _useExtendedDeliveryLanguage, _storeIdentifier = ref.storeIdentifier, storeIdentifier = _storeIdentifier === void 0 ? getStoreIdentifier() : _storeIdentifier;
    var createOverlayIframe = function createOverlayIframe(param) {
        var id = param.id, src = param.src;
        var iframe = document.createElement("iframe");
        iframe.id = id;
        iframe.src = src;
        iframe.style.position = "fixed";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.bottom = "0";
        iframe.style.right = "0";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.zIndex = "2147483647";
        return iframe;
    };
    var learnMoreIframeSrc = function learnMoreIframeSrc(param) {
        var iframeCommsId = param.iframeCommsId, isAddToPreorder = param.isAddToPreorder, storeIdentifier = param.storeIdentifier, useExtendedDeliveryLanguage = param.useExtendedDeliveryLanguage;
        return (0,url/* createURL */.Ri)({
            host: HOST,
            path: "/embedded-checkout/pre-order-value-prop",
            queryParams: (0,_object_spread/* default */.Z)({
                hideBackToProduct: hideBackToProduct,
                locale: autoDetectLocale(),
                isAddToPreorder: isAddToPreorder,
                useExtendedDeliveryLanguage: useExtendedDeliveryLanguage
            }, storeIdentifier),
            hash: "#!iframeId=".concat(iframeCommsId)
        });
    };
    var learnMoreBtn = document.createElement("span");
    learnMoreBtn.innerHTML = t("shopify:shopify-app.learn-more");
    learnMoreBtn.style.textDecoration = "underline";
    learnMoreBtn.style.cursor = "pointer";
    learnMoreBtn.style.background = "none";
    learnMoreBtn.style.border = "none";
    learnMoreBtn.addEventListener("click", function() {
        var onMessage = function onMessage(ev) {
            var data = ev.data;
            if (!data) {
                return;
            }
            if (data.meta && data.meta.messageType === "handshake-reply") {
                clearInterval(interval);
                return;
            }
            if (data.data && data.data.eventName === "dismiss-iframe") {
                var dismissIframe = document.querySelector("#".concat(id));
                if (dismissIframe) {
                    var ref;
                    (ref = dismissIframe.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(dismissIframe);
                }
            }
        };
        var sendHandshake = function sendHandshake() {
            var ref;
            if (!iframe) {
                return;
            }
            (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.postMessage({
                meta: {
                    messageType: "handshake"
                },
                data: {
                    iframeId: iframeCommsId
                }
            }, HOST);
        };
        var iframeCommsId = "d323029f-c21e-458b-9a73-957e7d87db32";
        var id = "pd-learn-more-iframe";
        var iframe = createOverlayIframe({
            id: id,
            src: learnMoreIframeSrc({
                iframeCommsId: iframeCommsId,
                isAddToPreorder: isAddToPreorder,
                storeIdentifier: storeIdentifier,
                useExtendedDeliveryLanguage: useExtendedDeliveryLanguage
            })
        });
        document.body.appendChild(iframe);
        var interval = setInterval(sendHandshake, 500);
        window.addEventListener("message", onMessage, false);
    });
    return learnMoreBtn;
}
function getStoreIdentifier() {
    var ref, ref1;
    if ((ref = window.PurpleDotConfig) === null || ref === void 0 ? void 0 : ref.apiKey) {
        var ref2;
        return {
            apiKey: (ref2 = window.PurpleDotConfig) === null || ref2 === void 0 ? void 0 : ref2.apiKey
        };
    }
    if ((ref1 = window.Shopify) === null || ref1 === void 0 ? void 0 : ref1.shop) {
        var ref3;
        return {
            shop: (ref3 = window.Shopify) === null || ref3 === void 0 ? void 0 : ref3.shop
        };
    }
    return {};
}

// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(62546);
// EXTERNAL MODULE: ./components/use-translation.ts + 7 modules
var use_translation = __webpack_require__(84687);
;// CONCATENATED MODULE: ./components/common/Branding.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 100%;\n\n  .text {\n    @media (max-width: 750px) {\n      font-size: ",
        ";\n      line-height: ",
        ";\n    }\n    color: var(--text-color-secondary);\n  }\n\n  .purple:before {\n    display: inline-block;\n    position: relative;\n    content: ' ';\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    bottom: 1px;\n    background-color: ",
        ";\n  }\n\n  .purple {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Branding = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, useExtendedDeliveryLanguage = param.useExtendedDeliveryLanguage, storeId = param.storeId;
    var t = (0,use_translation/* useTranslation */.$)().t;
    var textContainer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        var learnMoreButton = createLearnMoreButton({
            HOST: getOrigin(),
            hideBackToProduct: true,
            useExtendedDeliveryLanguage: useExtendedDeliveryLanguage,
            storeIdentifier: {
                storeId: storeId
            }
        });
        learnMoreButton.setAttribute("data-testid", "learn-more-button");
        learnMoreButton.setAttribute("class", "text");
        (ref = textContainer.current) === null || ref === void 0 ? void 0 : ref.appendChild(learnMoreButton);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "text",
            ref: textContainer,
            children: [
                useExtendedDeliveryLanguage ? t("translation:self-service.common.extended-delivery-powered-by") : t("translation:self-service.common.waitlist-powered-by"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "purple",
                    children: " Purple Dot"
                }),
                ".",
                " "
            ]
        })
    });
})(_templateObject(), function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "14px" : "auto";
}, function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "22px" : "auto";
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
});
function getOrigin() {
    return window.location.origin;
}
/* harmony default export */ var common_Branding = (Branding);


/***/ }),

/***/ 57565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7464);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62546);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  transition: all 0.3s linear;\n\n  text-transform: uppercase;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  letter-spacing: ",
        ";\n\n  &:disabled {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ThemedButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .ZP.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.enabled.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.letterSpacing;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.backgroundColor;
});
/* harmony default export */ __webpack_exports__["Z"] = (ThemedButton);


/***/ })

}]);